/* eslint-disable prettier/prettier */
/**
 * Asynchronously loads the component for FeaturePage
 */
import { loadable } from '@elliemae/pui-app-sdk';

export const LoadablePipelineConfiguration = loadable(
  () =>
    import(
      /* webpackChunkName: "pipeline" */ /* webpackPrefetch: true */ './monitor/PipelineMonitor'
    ),
);
export const LoadablePipelineRunDetailsPage = loadable(
  () =>
    import(
      // eslint-disable-next-line import/no-unresolved
      /* webpackChunkName: "runDetailsPage" */ /* webpackPrefetch: true */ './run/RunDetails'
    ),
);
export const LoadablePipelineClientRunDetailsPage = loadable(
  () =>
    import(
      // eslint-disable-next-line import/no-unresolved
      /* webpackChunkName: "runDetailsPage" */ /* webpackPrefetch: true */ './investor/InvestorRuns'
    ),
);
